export default {
  columnLabels: {
    view: 'View',
    title: 'Title',
    mediaType: 'Type',
    dateCreated: 'Date Created',
    type: 'Preset Type',
    scorecard: 'Scorecard',
    build: 'Build',
    delete: 'Delete'
  }
}



// WEBPACK FOOTER //
// ./src/app/configuration/ComcastOffer/config/components/selection/PresetSelect/PresetListView.js